import React, { Component } from 'react';
import './Recipe.css';
import Parser from "html-react-parser";
import Moment from 'react-moment';
import 'moment/locale/fr';
import Comments from "./Comments.container";

const recipes = require('../res/recipes.json');

class Recipe extends Component {

    constructor(props) {
        super(props);
    }

    componentWillMount() {
        // this.props.loadRecipe(this.props.match.params.label);
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.recipe.error) {
            nextProps.history.push('accueil/1');
        }
        return true;
    }

    componentWillUnmount() {
        this.props.clearRecipe();
    }

    render() {
        const { label } = this.props.match.params;

        const recipe = recipes.find(r => r.label === label)
        return (
            Object.keys(recipe).length > 1 ?
            <div className="article">
                <div className="article-header">
                    {recipe.title}
                </div>
                <div className="article-description">
                    <div>{Parser(recipe.description)}</div>
                </div>
                <div className="article-picture">
                    <img src={`/images/recipes/${recipe.picture}`} alt="picture" />
                </div>
                <div className="article-subtitle">INGREDIENTS&nbsp;
                    { recipe.quantity && <span>({recipe.quantity})</span> } :
                </div>
                <ul className="article-ingredients">
                    {
                        recipe.ingredients && recipe.ingredients.map(ingredient =>
                            <li key={ingredient} className="article-ingredient"><i className="fa fa-asterisk"></i>&nbsp;{ingredient}</li>
                        )
                    }
                    {
                        recipe['ingredients-multiple'] && recipe['ingredients-multiple'].map(ingredient =>
                            <div>
                                <span>{ingredient.title}</span>
                                {
                                    ingredient.ingredients && ingredient.ingredients.map(ing =>
                                        <li key={ing} className="article-ingredient"><i className="fa fa-asterisk"></i>&nbsp;{ing}</li>
                                    )
                                }
                                <br />
                            </div>
                        )
                    }
                </ul>
                <div className="article-subtitle">PREPARATION :</div>
                <div className="article-steps">{Parser(recipe.preparation)}</div>

                <div className="article-footer">
                    Publié le <Moment format="DD MMMM YYYY">{recipe.date}</Moment> par {recipe.author}
                </div>
                {/*<Comments comments={recipe.comments} totalComments={recipe.totalComments} recipeId={recipe.id} recipeLabel={recipe.label} />*/}
            </div> : null
        );
    }
}

export default Recipe;



// WEBPACK FOOTER //
// ./src/components/Recipe.js